import { Type } from '@angular/core';

export abstract class SettingsCard {
  abstract component: Type<any>;
  abstract pages: string[];
}
